import React from 'react'
import { EmailField } from '@therms/atalaya'
import {Field, FieldAttributes, useFormikContext} from 'formik'

function FormikEmail(props: FieldAttributes<Parameters<typeof EmailField>[0]>) {
  const form = useFormikContext()

  return (
      <Field name={props.name}>
        {({ field, meta }) => (
            <EmailField
                {...props}
                error={(meta.touched || !!form.submitCount) && meta.error}
                valid={(meta.touched || !!form.submitCount) && meta.value && !meta.error}
                {...field}
            />
        )}
      </Field>
  )
}

export { FormikEmail }
